<div class="grid">
  <app-page-header class="col-12" icon="pi pi-user" [title]="userId ? 'Edit Existing User' : 'Add User'" description="Create a user account or update an existing one."></app-page-header>
  <div class="col-12">
<div class="surface-card p-4 shadow-2 app-card">

    <form [formGroup]="registerForm" (ngSubmit)="onFormSubmit($event)">

      <div class="grid">

        <div class="field col-12 md:col-6">
          <label for="fname" class="block text-900 font-medium mb-2 dynamic-required">First Name</label>
          <input type="text" pInputText formControlName="firstName" id="fname" [ngClass]="{ 'ng-invalid ng-dirty' : registerForm.get('firstName')?.invalid }" class="w-full">
        </div>

        <div class="field col-12 md:col-6">
          <label for="lname" class="block text-900 font-medium mb-2 dynamic-required">Last Name</label>
          <input type="text" pInputText formControlName="lastName" id="lname" class="w-full">
        </div>

        <div class="field col-12 md:col-6">
          <label for="email" class="block text-900 font-medium mb-2 dynamic-required">Email</label>
          <input type="text" pInputText formControlName="email" id="email" [ngClass]="{ 'ng-invalid ng-dirty' : registerForm.get('email')?.invalid }" class="w-full">
        </div>

        <div class="field col-12 md:col-6">
          <label for="phone" class="block text-900 font-medium mb-2">Phone</label>
          <input type="text" pInputText formControlName="phone" id="phone" class="w-full">
        </div>

        <div class="field col-12 md:col-6" *ngIf="!userId|| isModal">
          <div class="flex justify-content-between">
            <label for="password" class="block text-900 font-medium mb-2 dynamic-required">Password</label>
            <span class="generate-random" (click)="generatePassword()">Generate Random</span>
          </div>
          <p-password type="password" [feedback]="true" [toggleMask]="true" formControlName="password" id="password"
            class="mb-3"
            [ngClass]="{ 'ng-invalid ng-dirty' : registerForm.get('password')?.invalid || registerForm.get('passwordConfirm')?.invalid }"
            class="w-full"></p-password>
        </div>

        <div class="field col-12 md:col-6" *ngIf="!userId || isModal">
          <label for="passwordConfirm" class="block text-900 font-medium mb-2 dynamic-required">Confirm Password</label>
          <p-password type="password" [feedback]="false" [toggleMask]="true" formControlName="passwordConfirm"
            id="passwordConfirm" class="mb-3"
            [ngClass]="{ 'ng-invalid ng-dirty' : registerForm.get('passwordConfirm')?.invalid }"
            class="w-full"></p-password>
        </div>
        <ng-container *ngIf="!isModal">

          <div *ngIf="(regions$ | async) as regions" class="field col-12 md:col-6">
            <label class="block text-900 font-medium mb-2 dynamic-required">Regions</label>
            <p-multiSelect *ngIf="regions.length" [options]="regions" optionValue="id" formControlName="regions"
              defaultLabel="Select Regions" optionLabel="name" display="chip" styleClass="chips-truncate"></p-multiSelect>
            <p-skeleton *ngIf="!regions.length" height="3rem"></p-skeleton>
          </div>

          <div *ngIf="(roles$ | async) as roles" class="field col-12 md:col-6">
            <label class="block text-900 font-medium mb-2 dynamic-required">Roles</label>
            <p-multiSelect *ngIf="roles.length" [options]="roles" optionValue="id" formControlName="roles"
              defaultLabel="Select Roles" optionLabel="name" display="chip" styleClass="chips-truncate"></p-multiSelect>
            <p-skeleton *ngIf="!roles.length" height="3rem"></p-skeleton>
          </div>
        </ng-container>

        <!-- Public-visibility gate — shown when editing an existing user. The
             actual profile content (job title, bio, credentials, languages) is
             edited by the arranger on their own profile/settings page; here the
             admin only controls whether it's published. -->
        <ng-container *ngIf="userId">
          <div class="col-12">
            <hr class="my-2">
            <span class="text-600 font-medium text-sm">Director Profile (shown on picaluna.com.au)</span>
          </div>

          <!-- Admin gate for public visibility. Independent of Enable/Disable:
               a trainee can be an active user but kept off the public site
               until they've completed a couple of arrangements. -->
          <div class="field col-12">
            <div class="flex align-items-center justify-content-between surface-100 border-round-lg p-3">
              <div class="flex flex-column gap-1">
                <label for="isPublicProfile" class="text-900 font-medium">Show on picaluna.com.au</label>
                <small class="text-600">
                  When on, this director appears on the public website. Disabled users are never shown,
                  regardless of this setting. The director edits their own bio, credentials and
                  languages from their profile page.
                </small>
              </div>
              <p-inputSwitch formControlName="isPublicProfile" inputId="isPublicProfile"></p-inputSwitch>
            </div>
          </div>

          <!-- Staging preview of the director page (drafts included) — hidden
               when the publishing pipeline isn't configured. -->
          <div class="field col-12" *ngIf="stagingBaseUrl">
            <div class="flex align-items-center gap-2 flex-wrap surface-100 border-round-lg p-3">
              <div class="flex flex-column gap-1 flex-auto">
                <span class="text-900 font-medium">Staging preview</span>
                <small class="text-600">
                  Review the rendered director page on the private staging site before switching the
                  profile on. Builds from saved data; takes a few minutes.
                </small>
              </div>
              <button
                pButton
                pRipple
                type="button"
                label="Preview on staging"
                icon="pi pi-eye"
                class="p-button-outlined flex-initial"
                [loading]="previewRequesting || previewBuilding"
                (click)="onPreviewProfileOnStaging()"
              ></button>
              <a *ngIf="stagingProfileUrl" [href]="stagingProfileUrl" target="_blank" rel="noopener">
                <button
                  pButton
                  pRipple
                  type="button"
                  label="View on staging"
                  icon="pi pi-external-link"
                  class="p-button-text flex-initial"
                ></button>
              </a>
            </div>
            <small *ngIf="previewBuilding" class="block mt-1 text-primary">
              <i class="pi pi-spin pi-spinner mr-1"></i>Building preview — usually 3–4 minutes…
            </small>
          </div>
        </ng-container>

        <div class="button-actions col-12 flex justify-content-end">

          <button type="button" *ngIf="!isModal && (currentUser$ | async) as currentUser" (click)="onToggleUserIsEnabled($event, currentUser)" pButton pRipple
            [label]="(currentUser.data.isEnabled === 1) ? 'Disable User' : 'Enable User'"
            [icon]="(currentUser.data.isEnabled === 1) ? 'pi pi-trash' : 'pi pi-check'"
            [ngClass]="{ 'p-button-danger' : currentUser.data.isEnabled === 1,'p-button-success' : currentUser.data.isEnabled !== 1 }"
            [loading]="isProcessingUserEnabled"></button>
          <button type="button" *ngIf="!isModal && (currentUser$ | async) as currentUser" (click)="onResetPassword($event, currentUser)" pButton pRipple
            label="Reset Password" icon="pi pi-lock" class="p-button-secondary"
            [loading]="isProcessingResetPassword"></button>
          <button type="submit" pButton pRipple label="Submit" icon="pi pi-save" [disabled]="registerForm.invalid"
            [loading]="isProcessingUser"></button>

        </div>

      </div>

    </form>

</div>
  </div>
</div>
